import { render, staticRenderFns } from "./SnapshotList.vue?vue&type=template&id=6090ab26&"
import script from "./SnapshotList.vue?vue&type=script&lang=js&"
export * from "./SnapshotList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports